export default __webpack_public_path__ + "static/media/message.30938901.svg";